import { Close } from "../Close/Close";
import { WindowCenteredContainer } from "../containers/WindowCenteredContainer/WindowCenteredContainer";
import { Text } from "../Text/Text";
import { Button } from "../Button/Button";

import styles from "./Agreement.module.scss";

export const Agreement = ({ title, children }) => (
  <div className={styles.container}>
    <WindowCenteredContainer
      maxWidth="lg"
      style={{
        background: "white",
        borderRadius: 20,
        margin: "auto",
        padding: "60px 80px 40px 80px",
        maxHeight: "80vh",
      }}
    >
      <Text bold title>
        {title}
      </Text>
      <div style={{ overflowY: "auto" }}>{children}</div>
      <Button onClick={() => window.close()} style={{ marginTop: 20 }}>
        Продолжить регистрацию
      </Button>
      <Close />
    </WindowCenteredContainer>
  </div>
);
